// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-action-template/src/index.tsx

// TODO: Check if the icon is alined properly.
// If it is not: Replace/extend defaultAlignedActionIconGroupProps to make it look right.
// https://stash.int.klarna.net/projects/UI/repos/bubble-ui/pull-requests/121/overview?commentId=2244923
import baseIcon, { defaultAlignedActionIconGroupProps } from '@bubble-ui/temp-icon-base';
var ActionIconDarkModePath = 'M7.058.095A6 6 0 1 1 .093 7.058c2.233.699 4.465.384 5.907-1.058C7.44 4.559 7.757 2.326 7.058.095Zm2.236 3.637-.015.093c-.257 1.362-.877 2.601-1.865 3.59-.988.987-2.227 1.607-3.59 1.864l-.092.015.112.076a4.002 4.002 0 0 0 4.825-.39l.16-.152a4.001 4.001 0 0 0 .54-4.984l-.075-.112Z';
var ActionIconDarkMode = baseIcon('ActionIconDarkMode', {
  groupProps: defaultAlignedActionIconGroupProps,
  getPath: () => ActionIconDarkModePath
});
export default ActionIconDarkMode;
//# sourceMappingURL=index.js.map